import React from 'react';

import { styled } from '@mui/material';
import PropTypes from 'prop-types';

import { TypographyEllipsis } from 'components/Templates/TypographyEllipsis';

const getColor = theme => ({
  draft: {
    color: theme.palette.draft.main,
    backgroundColor: theme.palette.draft.light,
  },
  info: {
    color: theme.palette.info.main,
    backgroundColor: theme.palette.info.light,
  },
  success: {
    color: theme.palette.success.main,
    backgroundColor: theme.palette.success.light,
  },
  warning: {
    color: theme.palette.warning.main,
    backgroundColor: theme.palette.warning.light,
  },
  error: {
    color: theme.palette.error.main,
    backgroundColor: theme.palette.error.light,
  },
});

const TypographyEllipsis_Label = styled(TypographyEllipsis)(({ theme, color }) => ({
  color: getColor(theme)[color]?.color || getColor(theme).draft.color,
  backgroundColor: getColor(theme)[color]?.backgroundColor || getColor(theme).draft.backgroundColor,
  padding: theme.spacing(0.5, 2),
  borderRadius: 4,
}));

const Tile = ({ className, label, color = 'draft' }) =>
  !label ? null : (
    <TypographyEllipsis_Label
      className={className}
      component="span"
      variant="subtitle"
      color={color}
    >
      {label}
    </TypographyEllipsis_Label>
  );

Tile.propTypes = {
  className: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  color: PropTypes.oneOf(['draft', 'info', 'success', 'warning', 'error']),
};

export default Tile;
